import { render, staticRenderFns } from "./RadialBubbleChart.vue?vue&type=template&id=5810057e&scoped=true"
import script from "./RadialBubbleChart.vue?vue&type=script&lang=js"
export * from "./RadialBubbleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5810057e",
  null
  
)

export default component.exports